<template>
  <b-modal
    v-model="show"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    @hide="hideModal"
  >
    <form
      v-if="user"
      id="addModal"
      @submit.prevent="addUser"
    >
      <div class="modal-header align-items-center">
        <h2
          id="ModalLabel"
          class="modal-title"
        >
          Добавление пользователя
        </h2>
        <i class="material-icons">group_add</i>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label
            for="email"
            class="col-form-label"
          >
            E-mail:
          </label>
          <input
            id="email"
            ref="email"
            v-model="params.email"
            type="email"
            class="form-control"
            placeholder="example@mail.com"
            required
          >
        </div>
        <div class="form-group">
          <label
            for="name"
            class="col-form-label"
          >
            Имя на портале:
          </label>
          <input
            id="name"
            v-model="params.name"
            class="form-control"
            placeholder="Имя пользователя"
          >
        </div>
        <div class="form-group">
          <label
            for="groups"
            class="col-form-label"
          >
            Роль:
          </label>
          <multiselect
            v-model="userRoles"
            :options="roleList"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            placeholder="Выберите роль"
            selected-label="Роль добавлена"
            select-label="Добавить роль"
            deselect-label="Убрать роль"
            label="description"
            track-by="description"
          >
            <template slot="noResult">
              По данному запросу ничего не найдено
            </template>
            <template slot="noOptions">
              Нет доступных ролей
            </template>
          </multiselect>
        </div>
        <div
          v-if="hasDealerCode && (canSetAnyUR || canSetUR)"
          class="form-group"
        >
          <label
            for="UR"
            class="col-form-label"
          >
            Дилер
          </label>
          <multiselect
            v-model="dealersSelected"
            :options="dealerList"
            :multiple="true"
            :taggable="canSetAnyUR"
            :loading="isLoading"
            :placeholder="dealersSelectLabel"
            tag-placeholder="Добавить новый UR-код"
            selected-label=""
            select-label="Выбрать"
            deselect-label="Отменить"
            label="URCode"
            track-by="URCode"
            @tag="addURCode"
          >
            <template slot="noResult">
              По данному запросу ничего не найдено
            </template>
            <template slot="noOptions">
              Нет доступных дилеров
            </template>
          </multiselect>
        </div>
        <div
          v-if="hasSupplierCode && user.interfaces.includes('UM-user-set-gsdb')"
          class="form-group"
        >
          <label
            for="GSDB"
            class="col-form-label"
          >
            GSDB
          </label>
          <input
            id="GSDB"
            v-model="params.GSDBCode"
            class="form-control"
            placeholder="XXXXX"
            maxlength="5"
            minlength="5"
          >
        </div>
        <div
          v-if="hasCarrierCode && user.interfaces.includes('UM-user-set-carrier')"
          class="form-group"
        >
          <label
            for="Carrier Code"
            class="col-form-label"
          >
            Carrier
          </label>
          <multiselect
            v-model="carrier.selected"
            :options="carrier.list"
            :options-limit="5"
            :show-no-results="false"
            :loading="carrier.loading"
            track-by="id"
            label="name"
            placeholder="-"
            @open="carrierOpen"
            @search-change="carrierSearch"
          >
            <template #singleLabel="{ option }">
              {{ option.name }}
            </template>
            <template #option="{ option }">
              {{ option.name }}
            </template>
          </multiselect>
        </div>
        <div
          v-if="hasClaimAgentCode && user.interfaces.includes('UM-user-set-claim-agent')"
          class="form-group"
        >
          <label
            for="ClaimAgent Code"
            class="col-form-label"
          >
            Претензионный агент:
          </label>
          <multiselect
            v-model="claimAgent.selected"
            :options="claimAgent.list"
            :options-limit="5"
            :multiple="true"
            :show-no-results="false"
            :loading="claimAgent.loading"
            track-by="id"
            label="name"
            placeholder="-"
            @open="claimAgentOpen"
            @search-change="claimAgentSearch"
          >
            <template #singleLabel="{ option }">
              {{ option.name }}
            </template>
            <template #option="{ option }">
              {{ option.name }}
            </template>
          </multiselect>
        </div>
        <div class="form-group">
          <label
            for="phone"
            class="col-form-label"
          >
            Рабочий телефон
          </label>
          <the-mask
            id="phone"
            v-model="params.phone"
            :mask="['+### (##) ###-##-##', '+# (###) ###-##-##']"
            masked
            class="form-control"
            placeholder="+7 (921) 123-45-67 или +375 (92) 123-45-67"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-secondary-ford-gray modal-ext"
          type="button"
          @click="hideModal"
        >
          Отмена
        </button>
        <button
          class="btn btn-primary-ford-orange modal-ext"
          type="submit"
        >
          <i class="material-icons">add</i>
          Добавить
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { mongoRegexI } from '@/utils/mongo-regex';

export default {
  name: 'AddUser',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
    roleList: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    show: false,
    params: {
      GSDBCode: '',
      email: '',
      name: '',
      phone: '',
      URCodes: [],
    },
    carrier: {
      selected: '',
      list: [],
      loading: false,
    },
    claimAgent: {
      selected: '',
      list: [],
      loading: false,
    },
    manuallyEnteredURCode: null,
    dealersSelected: [],
    userRoles: [],
    dealerList: [],
    isLoading: false,
  }),
  computed: {
    userSelf() {
      return this.$store.state.user;
    },
    canSetUR() {
      return this.userSelf.interfaces.includes('UM-user-set-ur');
    },
    canSetAnyUR() {
      return this.userSelf.interfaces.includes('UM-user-set-any-ur');
    },
    userRolesFormatted() {
      return this.userRoles.map(it => it.name);
    },
    dealersSelectLabel() {
      return `Выберите URCode${this.canSetAnyUR ? ' или добавьте новый' : ''}`;
    },
    hasDealerCode() {
      return ['dealerSVO', 'dealerCB', 'dealerAdministratorCB', 'dealerAdministratorSVO']
        .some((role) => this.userRolesFormatted.includes(role));
    },
    hasSupplierCode() {
      return ['supplierCB', 'supplierAdministratorCB']
        .find((role) => this.userRolesFormatted.includes(role));
    },
    hasClaimAgentCode() {
      return this.userRolesFormatted.includes('claimAgentSVO');
    },
    hasCarrierCode() {
      return this.userRolesFormatted.includes('carrierSVO');
    },
  },
  watch: {
    value(val) {
      this.show = val;
    },
  },
  created() {
    if (this.canSetAnyUR) {
      this.getDealers();
      return;
    }

    if (this.canSetUR) {
      this.dealerList = this.$store.state.user.URCodes.map(it => ({ URCode: it }));
    }
  },
  methods: {
    hideModal() {
      this.$emit('input', false);
      this.setDefaultState();
    },
    showErrorToast(message) {
      this.$bvToast.toast(message, {
        title: 'Ошибка',
        variant: 'danger',
        solid: true,
        autoHideDelay: 15000,
      });
    },
    validatePhone() {
      const phone = this.params.phone;
      if (!phone) return true;

      return /^(\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}|\+375 \(\d{2}\) \d{3}-\d{2}-\d{2})$/.test(phone);
    },
    async addUser() {
      if (!this.validatePhone()) {
        this.showErrorToast('Некорректный формат телефона. Телефон должен быть в формате +7 (XXX) XXX-XX-XX или +375 (XX) XXX-XX-XX.');
        return;
      }

      if (this.hasDealerCode && this.dealersSelected.length) {
        this.params.URCodes = this.dealersSelected.map(it => it.URCode);
      } else {
        this.params.URCodes = [];
      }

      if (this.hasCarrierCode) {
        this.params.CarrierCode = this.carrier.selected.code;
      }

      if (this.hasClaimAgentCode) {
        this.params.ClaimAgentCodes = (this.claimAgent.selected || []).map(agent => agent.code);
      }

      await this.$http.put('users/1.0/users', {
        ...this.params,
        role: this.userRolesFormatted,
      });

      this.$emit('addUser');
      this.setDefaultState();
    },
    setDefaultState() {
      setTimeout(() => {
        Object.assign(this.$data.params, this.$options.data().params);
        this.dealersSelected = [];
        this.manuallyEnteredURCode = null;
        this.userRoles = [];
      }, 500);
    },
    async getDealers() {
      this.isLoading = true;
      try {
        const { items } = await this.$http.get('dealers/1.0/dealers');
        this.dealerList = items;
      } finally {
        this.isLoading = false;
      }
    },
    addURCode(URCode) {
      this.dealersSelected.push({ URCode });
    },

    carrierOpen() {
      if (!this.carrier.list.length) {
        this.carrierSearch();
      }
    },

    async carrierSearch(searchStr) {
      this.carrier.loading = true;

      try {
        const { rows } = await this.$http.get('carriers', {
          params: {
            limit: 5,
            query: {
              isActive: true,
              ...(searchStr ? { name: mongoRegexI(searchStr) } : {}),
            },
          },
        });

        this.carrier.list = rows.map((item) => ({ id: item.id, name: item.name, code: item.code }));
      } finally {
        this.carrier.loading = false;
      }
    },

    claimAgentOpen() {
      if (!this.claimAgent.list.length) {
        this.claimAgentSearch();
      }
    },

    async claimAgentSearch(searchStr) {
      this.claimAgent.loading = true;

      try {
        const { rows } = await this.$http.get('claim-agents', {
          params: {
            limit: 5,
            query: {
              isActive: true,
              ...(searchStr ? { name: mongoRegexI(searchStr) } : {}),
            },
          },
        });

        this.claimAgent.list = rows.map((item) => ({ id: item.id, name: item.name, code: item.code }));
      } finally {
        this.claimAgent.loading = false;
      }
    },
  },
};
</script>
